import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validation-matricula"
export default class extends Controller {
  static targets = [ "form", "matriculaInput", "nombreInput", "tabs" ]
  static values = {
    id: String
  }

  connect() {
    // Bloquear ENTER solo para evitar submit automático del formulario principal
    this.element.addEventListener('keydown', this.preventFormSubmitOnEnter.bind(this));

    // Mantener el handler específico para el modal de matrícula
    this.element.addEventListener('keydown', this.handleModalKeydown.bind(this));

    try {
      if (this.hasMatriculaInputTarget && this.matriculaInputTarget) {
        this.matriculaInputTarget.addEventListener('input', () => {
          const hidden = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]');
          if (hidden) hidden.value = '';
        });
      }
    } catch (e) {}
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.preventFormSubmitOnEnter.bind(this));
    this.element.removeEventListener('keydown', this.handleModalKeydown.bind(this));
  }

  preventFormSubmitOnEnter(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const form = document.getElementById(this.idValue);

      // Si estamos en el formulario principal (no en el modal)
      const isInModal = target.closest('#matriculaValidacionModal');

      if (!isInModal && form.contains(target)) {
        // Permitir ENTER en el editor Trix (campo de informe)
        const isTrixEditor = target.tagName === 'TRIX-EDITOR' || target.closest('trix-editor');
        if (isTrixEditor) {
          return; // Permitir comportamiento normal en Trix
        }

        // Solo prevenir si el target es un input/textarea (no un botón)
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          event.preventDefault();
          return false;
        }
      }
    }
  }

  handleModalKeydown(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const isInModal = target.closest('#matriculaValidacionModal');

      // Solo actuar si estamos dentro del modal
      if (isInModal && this.hasMatriculaInputTarget) {
        event.preventDefault();

        const matriculaValue = this.matriculaInputTarget.value;

        if (matriculaValue) {
          this.submitForm();
        } else {
          this.matriculaInputTarget.focus();
        }
      }
    }
  }

  openModal(e) {
    e.preventDefault();
    this.originalSubmitButton = e.target;
    if (this.originalSubmitButton.classList.contains("disabled")) {
      return;
    }

    $('#matriculaValidacionModal').modal('show');
  }

  submitForm() {
    const matriculaTexto = this.hasMatriculaInputTarget ? this.matriculaInputTarget.value.trim() : ''
    const hiddenField = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]')
    const matriculaSeleccionada = hiddenField ? (hiddenField.value || '').toString().trim() : ''

    if (matriculaTexto === '' || matriculaSeleccionada === '') {
      alert('Debes seleccionar un profesional del buscador. Escribe y elige una opción de la lista desplegable.');
      return
    }

    const form = document.getElementById(this.idValue)
    form.requestSubmit();
    $('#matriculaValidacionModal').modal('hide');
  }

  getActiveTabName() {
    if (!this.hasTabsTarget) return null

    const activeTab = this.tabsTarget.querySelector(".nav-link.active")
    if (activeTab) {
      return activeTab.textContent.trim()
    }
    return null
  }

  closeModal() {
    $('#matriculaValidacionModal').modal('hide');
  }
}
